import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { PROJECTS } from '@/store/entities/schema_types';
import { contactRequestProjectClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters(PROJECTS),
  actions: {
    ...resourceActions,
    async read(ctx, { id, query = {} }) {
      try {
        const response = await client.read(id, query);

        const { data } = response;

        const userId = await ctx.dispatch(
          'entities/persistEntities',
          { type: PROJECTS, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdByParent',
          parentId: id,
          id: userId,
        });

        return Promise.resolve({ userId });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async update(ctx, { id, formData }) {
      try {
        await client.update(id, mapKeysToSnakeCase(formData));

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
